




























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Emit } from "vue-property-decorator";
import { Timeline } from "@/models/timeline.model";
import { BListGroup, BFormInput, BPagination, BSpinner } from "bootstrap-vue";
import AppTimelineItem from "./AppTimelineItem.vue";
import AppHeading from "../AppHeading.vue";

@Component({
  name: "AppTimeline",
  data() {
    return {
      search: "",
      currentPage: 1,
      isLoading: false
    };
  },
  components: { BListGroup, BFormInput, AppTimelineItem, AppHeading, BPagination, BSpinner }
})
export default class AppTimeline extends Vue {
  @Prop({ required: true }) timeline: Timeline;
  @Prop() total!: number;
  @Prop() perPage!: number;

  isLoading!: boolean;

  @Watch("timeline", { immediate: true })
  onTimelineChanged() {
    this.isLoading = false;
  }

  @Watch("currentPage")
  @Emit("paged")
  onCurrentPageChanged(newCurrentPage: number) {
    this.isLoading = true;
    return newCurrentPage;
  }
}
